'use client'

import React from 'react'

import BodyTitle from './sections/BodyTitle.component'
import BodyText from './sections/BodyText.component'
import BodyImage from './sections/BodyImage.component'
import BodyQuote from './sections/BodyQuote.component'

import * as S from './PostBody.styles'

const PostBody = ({ sections }) => {
  const dispatcher = {
    BlogTitle: BodyTitle,
    BlogText: BodyText,
    BlogImage: BodyImage,
    BlogQuote: BodyQuote,
  }

  return sections && sections.length > 0 ? (
    <S.PostBody>
      {sections.map((item, i) => {
        const Component = dispatcher[item.type]
        return Component ? (
          <Component {...item} key={`BlogPostBody-Section-${i}`} />
        ) : null
      })}
    </S.PostBody>
  ) : null
}

export default PostBody
